<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索柜子"
                   v-model="pageInfo.shopName">
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>
        <div class="page-state" v-if="!isCabinetToolBuyerRole">
            <van-tabs v-model="tabActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
                <van-tab :title="item.title" :name="item.value" v-for="(item,$index) in tabList"
                         :key="$index"></van-tab>
            </van-tabs>
        </div>
        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div v-for="(item,$index) in data" :key="$index" class="list-item"
                     @click="getScrollerPosition();$router.push({name:'supplyRecordDetail',query:{batchNo:item.batchNo,eqType:item.equipmentType}})">
                    <div class="flex supply-top-name bd-bot">
                        <div class="supply-label">{{equipment_type[item.equipmentType]}}</div>
                        <div class="flex1 color-333">{{item.shopName}}</div>
                        <div class="ml-20" :class="item.isVerify == '0'?'color-org':'color-000'" v-if="!isCabinetToolBuyerRole">{{item.isVerify == '0'?'待确认':"已处理"}}
                        </div>
                    </div>
                    <div class="pd-25">
                        <div class="flex-between fs-28 color-999">
                            <div>补货人：{{item.linkName}}</div>
                            <div>{{item.createTime}}</div>
                        </div>
                        <div v-if="item.equipmentType == 'rfid'">  <!---RFID柜---->
                            <div class="flex-center mt-30 fs-28">
                                <div class="mr-50" :class="item.addTypeCount && item.addTypeCount != 0?'color-org font-bold':'color-999'" v-if="!isCabinetToolBuyerRole">补货品种：{{item.addTypeCount}}</div>
                                <div  :class="item.minusTypeCount && item.minusTypeCount != 0?'color-main font-bold':'color-999'">取货品种：{{item.minusTypeCount}}</div>
                            </div>
                            <div class="flex-center mt-8 fs-28">
                                <div class="mr-50" :class="item.addNum && item.addNum != 0 ?'color-org font-bold':'color-999'" v-if="!isCabinetToolBuyerRole">补货数量：{{item.addNum}}</div>
                                <div :class="item.minusNum && item.minusNum != 0?'color-main font-bold':'color-999'">取货数量：{{item.minusNum}}</div>
                            </div>
                        </div>
                        <div v-if="item.equipmentType == 'weigh'"> <!---称重柜---->
                            <div class="flex-center mt-30 fs-28">
                                <div class="mr-50" :class="item.addTypeCount && item.addTypeCount != 0?'color-org font-bold':'color-999'" v-if="!isCabinetToolBuyerRole">补货品种：{{item.addTypeCount}}</div>
<!--                                <div class="color-999 ml-50">换绑货道：0</div>-->
                                <div :class="item.minusTypeCount && item.minusTypeCount != 0?'color-main font-bold':'color-999'">取货品种：{{item.minusTypeCount}}</div>
                            </div>
                        </div>
                        <div v-if="item.equipmentType == 'spring'"> <!---弹簧柜---->
                            <div class="flex-center mt-30 fs-28">
                                <div class="color-org mr-50">补货货道：</div>
                                <div class="color-999">换绑货道：</div>
                            </div>
                            <div class="flex-center mt-15 fs-28">
                                <div class="color-org">补货数量：{{item.addNum}}</div>
                            </div>
                        </div>
                        <div v-if="item.equipmentType == 'consign'"> <!---格子柜---->
                            <div class="flex-center mt-30 fs-28">
                                <div class="color-org mr-50" v-if="!isCabinetToolBuyerRole">补货品种：{{item.addTypeCount}}</div>
                                <div class="color-999">取货数量：{{item.minusNum}}</div>
                            </div>
                            <div class="flex-center mt-15 fs-28">
                                <div class="color-999">换绑货道：</div>
                            </div>
                        </div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";

    export default {
        name: "list",
        mixins: [initData, routerBack, getAppStatusHeight],
        components: {appStatus},
        data() {
            return {
                tabList: [
                    {title: '全部', value: ' '},
                    {title: '待确认', value: '0'},
                    {title: '已处理', value: '1'},
                ],
                tabActive: ' ',
                tabValue: '',
                equipment_type: {
                    spring: '弹簧柜',
                    rfid: 'RFID柜',
                    consign: '格子柜',
                    weigh: '称重柜'
                },
                isCabinetToolBuyerRole: this.$store.state.user.isCabinetToolBuyerRole || false,
            }
        },

        methods: {
            back() {
                if (this.isBackClose) {
                    try {
                        window.native.onFinish();
                    } catch (e) {

                    }
                } else {
                    try {
                        window.native.onBack();
                    } catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            beforeInit() {
                this.params = {page: this.page, limit: this.limit, isVerify: this.tabValue};
                this.url = 'item/stockLog/qryStockLogPage';
                let query = this.pageInfo;
                for (var key in query) {
                    if (query[key]) {
                        this.params[key] = query[key]
                    }
                }
                return true
            },
            //切换状态
            tabClick(name) {
                switch (name) {
                    case ' ':
                        this.tabValue = null;
                        break;
                    case '0':
                        this.tabValue = 0;
                        break;
                    case '1':
                        this.tabValue = 1;
                        break;
                }
                this.handleQuery();
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "supplyRecordDetail") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack || this.$store.state.updateSupplyRecordList) {
                this.$store.state.updateSupplyRecordList = false;
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .page-state {
        top: .9rem;
    }

    .list-item {
        margin: .24rem;
        background: #fff;
        border-radius: .12rem;
    }
</style>



// WEBPACK FOOTER //
// list.vue?52616899